import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userToken: null, // Token for authentication
    userData: null,    // User details
    userDashboard: null,    // User Dashboard details
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserToken: (state, action) => {
            state.userToken = action.payload;
        },
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
        setUserDashboardData: (state, action) => {
            state.userDashboard = action.payload;
        },
        clearUser: (state) => {
            state.userToken = null;
            state.userData = null;
            state.userDashboard = null;
        },
    },
});

export const { setUserToken, setUserData, setUserDashboardData, clearUser } = userSlice.actions;
export default userSlice.reducer;
